import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from '../../app-routing.module';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NgbDatepickerConfig,
  NgbDatepickerModule, NgbDropdown, NgbDropdownMenu, NgbDropdownToggle,
  NgbInputDatepickerConfig,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import {FilterPipeModule} from 'ngx-filter-pipe';
import {QuillModule} from 'ngx-quill';
import { SendEmailComponent } from './send-email/send-email.component';
import { SendEmailModalComponent} from './send-email-modal/send-email-modal.component';
import { DecimalNewPipe } from './DecimalNewPipe';
import {CustomFilterPipe} from './custom-filter.pipe';
import {FormHeaderButtonsComponent} from './form-header-buttons/form-header-buttons.component';
import { ActivityFeedComponent } from './activity-feed/activity-feed.component';
import { ArraySortPipe } from './orderBy';
import { Prevent2xClickDirective } from './prevent-2xClick.directive';
import { SearchComponent } from './search/search.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { Error400PageComponent } from './error400-page/error400-page.component';
import {NotAuthorizedPageComponent} from './not-authorized-page/not-authorized-page.component';
import { SearchFilterPipe } from './search-filter/search-filter.pipe';
import { AccountModalComponent } from './account-modal/account-modal.component';
import { SubtotalForAccountModalComponent } from './subtotal-for-account-modal/subtotal-for-account-modal.component';
import { AuditTrailModalComponent } from './audit-trail-modal/audit-trail-modal.component';
import {WidgetModule} from './widget/widget.module';
import { Error500PageComponent } from './error500-page/error500-page.component';
import {ResetPasswordComponent} from '../reset-password/reset-password.component';
import {NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { BsToastComponent } from './bs-toast/bs-toast-component';
import { BsToasterComponent } from './bs-toaster/bs-toaster.component';
import { ActivityFeedModalComponent } from './activity-feed-modal/activity-feed-modal.component';
import { CustomArrayFilterPipe } from './custom-array-filter.pipe';
import { ChangeBatchModalComponent } from './change-batch-modal/change-batch-modal.component';
import {AccountTreeViewModalComponent} from './account-tree-view-modal/account-tree-view-modal.component';
import { ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';
import { BatchNewAndPostModalComponent } from './batch-new-and-post-modal/batch-new-and-post-modal.component';
import {InactivityModalComponent} from './inactivity-modal/inactivity-modal.component';
import { OnlyNumberDirective } from './only-number.directive';
import { OnlyDecimalDirective} from './only-decimal.directive';
import {SearchFilterPipeActivityFeed} from './search-filter/search-filter-activity-feed.pipe';
import {SearchFilterPipeAuditTrail} from './search-filter/search-filter-audit-trail.pipe';
import {SearchFilterPipeChangeBatch} from './search-filter/search-filter-change-batch.pipe';
import {SearchFilterPipeBatchNewPost} from './search-filter/search-filter-batch-new-post.pipe';
import {DataTableComponent} from './data-table/data-table.component';
import {LightTableComponent, LightTableCellDirective} from './light-table/light-table.component';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {AsArrayPipe} from './as-array/as-array.pipe';
import {CustomDatepickerConfig} from './ngb-datepicker/custom-datepicker-config';
import {FormPageComponent} from './form-page/form-page.component';
import {LinkifyPipe} from './linkify.pipe';
import {ModalSelectAccountComponent} from '../transactions/resources/modal-select-account/modal-select-account.component';
import {AccountGroupedListSelectComponent} from './account-grouped-list-select/account-grouped-list-select.component';


@NgModule({
  declarations: [
    AuditTrailComponent,
    SendEmailComponent,
    SendEmailModalComponent,
    DecimalNewPipe,
    CustomFilterPipe,
    FormHeaderButtonsComponent,
    ActivityFeedComponent,
    ArraySortPipe,
    Prevent2xClickDirective,
    SearchComponent,
    FileUploadComponent,
    Error400PageComponent,
    NotAuthorizedPageComponent,
    SearchFilterPipe,
    SearchFilterPipeActivityFeed,
    SearchFilterPipeAuditTrail,
    SearchFilterPipeChangeBatch,
    SearchFilterPipeBatchNewPost,
    AccountModalComponent,
    SubtotalForAccountModalComponent,
    AuditTrailModalComponent,
    Error500PageComponent,
    ResetPasswordComponent,
    BsToastComponent,
    BsToasterComponent,
    ActivityFeedModalComponent,
    CustomArrayFilterPipe,
    ChangeBatchModalComponent,
    ConfirmDialogComponent,
    BatchNewAndPostModalComponent,
    InactivityModalComponent,
    AccountTreeViewModalComponent,
    OnlyNumberDirective,
    OnlyDecimalDirective,
    DataTableComponent,
    LightTableComponent,
    LightTableCellDirective,
    AsArrayPipe,
    FormPageComponent,
    LinkifyPipe,
    ModalSelectAccountComponent,
    AccountGroupedListSelectComponent,
  ],
  exports: [
    AuditTrailComponent,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    SendEmailComponent,
    SendEmailModalComponent,
    DecimalNewPipe,
    CustomFilterPipe,
    FormHeaderButtonsComponent,
    ActivityFeedComponent,
    // Export shared orderBy pipe
    ArraySortPipe,
    Prevent2xClickDirective,
    SearchComponent,
    FileUploadComponent,
    SearchFilterPipe,
    AccountModalComponent,
    SubtotalForAccountModalComponent,
    AccountTreeViewModalComponent,
    AuditTrailModalComponent,
    BsToasterComponent,
    ActivityFeedModalComponent,
    CustomArrayFilterPipe,
    ChangeBatchModalComponent,
    ConfirmDialogComponent,
    BatchNewAndPostModalComponent,
    InactivityModalComponent,
    FilterPipeModule,
    OnlyNumberDirective,
    OnlyDecimalDirective,
    DataTableComponent,
    LightTableComponent,
    LightTableCellDirective,
    AsArrayPipe,
    FormPageComponent,
    LinkifyPipe,
    ModalSelectAccountComponent,
    AccountGroupedListSelectComponent,
    NgbTooltipModule,
    NgbDatepickerModule,
    NgbTypeaheadModule,
    QuillModule,
  ], imports: [CommonModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule, // required animations module
    FilterPipeModule,
    WidgetModule,
    NgbAlertModule,
    NgbPaginationModule,
    NgbDatepickerModule,
    NgbTypeaheadModule,
    NgbTooltipModule,
    QuillModule.forRoot({
      theme: 'snow',
      modules: {
        toolbar: [
          [{'font': [false, 'serif', 'monospace']}],
          [{'size': ['small', false, 'large', 'huge']}],
          // [{ 'size': ['10px',false, '12px', '14px', '16px', '18px', '20px', '22px', '24px']}],
          ['bold', 'italic', 'underline'],
          [{'color': []}, {'background': []}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          ['link', 'clean']
        ],
        //   mention: {
        //     allowedChars: /^[A-Za-z0-9_ \-\:\.]*$/,
        //     mentionDenotationChars: ['@', '#'],
        //   }
      },
      format: 'html',
      customOptions: [
        {
          import: 'formats/font',
          whitelist: ['serif', 'monospace', 'arial', 'helvetica', 'sans-serif']
        },
        {
          import: 'formats/size',
          whitelist: ['small', 'large', 'huge']
        }
      ]
    }), NgbDropdown, NgbDropdownToggle, NgbDropdownMenu,
  ],
  providers: [
    {
      provide: NgbDatepickerConfig,
      useClass: CustomDatepickerConfig,
    },
    {
      provide: NgbInputDatepickerConfig,
      useFactory: (customConfig: CustomDatepickerConfig) => {
        const config = new NgbInputDatepickerConfig();
        Object.assign(config, customConfig);
        config.placement = 'bottom-start';
        config.autoClose = true;
        return config;
      },
      deps: [CustomDatepickerConfig],
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient()],
})
export class SharedModule {}
